import {  Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Lancamento } from '../../../pages/financeiro/conciliacao/models/lancamento';
import { ConciliacaoService } from '../../../pages/financeiro/conciliacao/services/conciliacao.service';
import { CorrespondenciaConciliacao } from '../../../pages/financeiro/conciliacao/models/correspondencia-conciliacao';

@Component({
  selector: 'app-exibe-correspondencia-dialog',
  standalone: false,
  templateUrl: './exibe-correspondencia-dialog.component.html',
  styleUrl: './exibe-correspondencia-dialog.component.scss'
})
export class ExibeCorrespondenciaDialogComponent implements OnInit {

  title: string = '';
  acaoDesfazer: boolean;
  lancamentosBanco: Lancamento[];
  lancamentosCaixa: Lancamento[];
  correspondenciaIndex: number;

  diferencaValores: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { acaoDesfazer: boolean, correspondenciaIndex: number },
    private conciliacaoService: ConciliacaoService
  ) { }

  ngOnInit(): void {
    this.acaoDesfazer = this.data.acaoDesfazer;
    
    const acao = this.acaoDesfazer ? "Desfazer" : "Visualizar";
    this.title = `${acao} Correspondencia`;

    this.correspondenciaIndex = this.data.correspondenciaIndex;
    const correspondencia = this.conciliacaoService.correspondenciasConciliacao[this.correspondenciaIndex];
    this.lancamentosBanco = correspondencia.lancamentosBanco;
    this.lancamentosCaixa = correspondencia.lancamentosCaixa;

    this.diferencaValores = this.lancamentosBanco.reduce((acc, l) => acc + l.valor, 0) 
      + this.lancamentosCaixa.reduce((acc, l) => acc + l.valor, 0);
  }

  public desfazerCorrespondenciaClick(): void {
    this.conciliacaoService.removerCorrespondenciaClick(this.correspondenciaIndex);
  }
}
